import React from 'react';
import { Typography, ListItem, ListItemText, Divider } from '@mui/material';

import { sxStyle } from './styles';

import parse from 'html-react-parser';

const CancellationPolicies = ({ hotelsValidateResult, divider = false }) => {
  return (
    hotelsValidateResult?.cancellation_policies?.length > 0 && (
      <>
        {divider && <Divider sx={sxStyle.divider} />}
        <Typography sx={sxStyle.title}>Políticas de cancelacion</Typography>
        {hotelsValidateResult?.cancellation_policies?.map((x, i) => (
          <ListItem
            style={{
              padding: 0,
            }}
            key={`cancellation_policies-${+i}`}
          >
            <ListItemText
              primary={
                <Typography sx={sxStyle.subTitle}>{parse(x)}</Typography>
              }
            />
          </ListItem>
        ))}
      </>
    )
  );
};

export default CancellationPolicies;
